import { Popover, PopoverContent, PopoverTrigger } from '@gettactic/components';
import { ArrowUpDown } from 'lucide-react';
import React from 'react';
import { SpotShape } from '../../../../../../types';
import { SpotPanelControls } from '../../../panels/SpotPanel/SpotPanelControls';

export interface ShapeToolboxSpotItemsProps {
  shape: SpotShape;
}

export const ShapeToolboxSpotItems: React.FC<ShapeToolboxSpotItemsProps> = ({
  shape
}) => {
  return (
    <>
      <div className="w-px h-4 bg-neutral-200" />
      <Popover>
        <PopoverTrigger asChild>
          <button
            className="p-1 rounded hover:bg-neutral-100 transition-colors flex items-center gap-1"
            title="Resource Options"
          >
            <ArrowUpDown size={16} className="text-neutral-600" />
          </button>
        </PopoverTrigger>
        <PopoverContent className="w-64 p-3" align="start">
          <SpotPanelControls shapes={[shape]} />
        </PopoverContent>
      </Popover>
    </>
  );
};
